



























































import { Messages } from "@/models/enums/messages.enum";
import { DataResponseCalendar } from "@/models/interface/assets.interface";
import { RequestQueryParamsModel } from "@/models/interface/http.interface";
import { assetsServices } from "@/services/assets.service";
import { generalJournalServices } from "@/services/generaljournal.service";
import { WrappedFormUtils } from "ant-design-vue/types/form/form";
import { Vue, Component } from "vue-property-decorator";
@Component
export default class OpenClose extends Vue {
  loadingCalendar = false as boolean;
  dataCalendar = [] as DataResponseCalendar[];
  loadingClose = false as boolean;
  form!: WrappedFormUtils;
  disabled = {
    close: false as boolean,
  };
  dataDetails = "" as any;
  formRules = {
    period: {
      label: "lbl_period_gl",
      name: "lbl_period_gl",
      placeholder: "lbl_period_gl",
      decorator: [
        "period",
        {
          rules: [
            {
              required: true,
              message: Messages.VALIDATION_REQUIRED_ERROR,
            },
          ],
        },
      ],
    },
    status: {
      label: "lbl_status",
      name: "lbl_status",
      placeholder: "lbl_status",
      decorator: ["status"],
    },
  };
  beforeCreate() {
    this.form = this.$form.createForm(this, { name: "closePeriod" });
  }
  mounted() {
    this.getListCalendar("");
  }
  filterOption(input, option) {
    return (
      option.componentOptions.children[0].componentOptions.children[1].text
        .toLowerCase()
        .indexOf(input.toLowerCase()) >= 0
    );
  }
  close(): void {
    this.loadingClose = true;
    generalJournalServices
      .closeGeneralJournal(`?period=${this.form.getFieldValue("period")}`)
      .then(() => {
        this.$notification.success({
          description: Messages.UPDATE_SUCCESS,
          message: "Success",
          duration: 30,
        });
        this.getListCalendar("");
        this.form.resetFields();
      })
      .catch(e => {
        this.$notification.error({
          description: Messages.UPDATE_FAIL,
          message: "Error",
          duration: 30,
        });
        this.$notification.error({
          description: e.details,
          message: "Error",
          duration: 30,
        });
      })
      .finally(() => (this.loadingClose = false));
  }
  handleCancel() {
    this.form.resetFields();
    this.$router.go(-1);
  }
  changeCalendar(value) {
    if (value) {
      this.form.setFieldsValue({
        status: !this.dataCalendar
          .find(item => item.month == value)
          ?.calendarClosePeriods.find(data => data.modulName == "GL")
          ?.closePeriod
          ? "OPEN"
          : "CLOSE",
      });
      this.dataDetails = this.dataCalendar
        .find(item => item.month == value)
        ?.calendarClosePeriods.find(data => data.modulName == "GL");
      if (
        !this.dataCalendar
          .find(item => item.month == value)
          ?.calendarClosePeriods.find(data => data.modulName == "GL")
          ?.closePeriod
      )
        this.disabled.close = false;
      else this.disabled.close = true;
    }
  }
  getListCalendar(valueSearch) {
    let params = {
      page: 0,
      limit: 10,
    } as RequestQueryParamsModel;
    if (valueSearch) params.search = `month~*${valueSearch}*`;
    this.loadingCalendar = true;
    let dataPeriode = [] as any;
    this.dataCalendar = [];
    assetsServices
      .listCalendar(params)
      .then(data => {
        data.data.forEach(element => {
          if (!element.month.includes("Adj")) dataPeriode.push(element);
        });
        this.dataCalendar = dataPeriode;
      })
      .finally(() => (this.loadingCalendar = false));
  }
  get formItemLayout() {
    return {
      labelCol: { span: 8 },
      wrapperCol: { span: 14 },
    };
  }
}
